export default __webpack_public_path__ + "static/media/property_95.787440a7.png";